export default __webpack_public_path__ + "static/media/amparo-arte-6.930dddd1.webp";